export const ADMIN_ROLE = 'Admin'
export const PROFESSIONAL_ROLE = 'Profesional'
export const PATIENT_ROLE = 'Paciente'
export const CENTER_ROLE = 'Centro'
export const ANONYMOUS_ROLE = 'Anonimo'
export const API_CLIENT_ROLE = 'ApiClient'

export const PATIENT_ROLE_ID = 'c8f59a92-fa8a-4506-b4cc-c5360028d2ee'
export const PROFESSIONAL_ROLE_ID = 'd7723d71-be50-4ea0-b1e5-81d86a16504b'
export const ADMIN_ROLE_ID = 'fa4fb7cc-daa0-4b7e-8126-31d0b5b2f972'
export const ADMIN_RESTRICTED_ROLE_ID  = 'cb7fb7cc-daa0-4b7e-4135-98d0b5b2f964'



// WEBPACK FOOTER //
// ./src/constants/roles.js